import { HerinneringDto } from "@/shared/types";

export type Herinnering = {
    id: number;
    scheduledAt: Date;
    titel: string;
};

export const Herinnering = {
    fromDto: (dto: HerinneringDto): Herinnering => ({
        id: dto.id,
        scheduledAt: new Date(dto.scheduledAt),
        titel: dto.tekst,
    }),
    sort: (a: Herinnering, b: Herinnering) => b.scheduledAt.getTime() - a.scheduledAt.getTime(),
};
